import React, { useState } from "react";
import { Container, TextField, Button } from "@mui/material";
import styled from "@emotion/styled";
import { setUser } from "../redux/session";
import { connect } from "react-redux";
import {
    signInEmailAndPassword,
    getCurrentUser,
    signUpEmailAndPassword,
    createNewUser,
} from "../firebase";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginLayout from "../components/login-layout";
import GoogleButton from "../components/google-button";
import { toast } from "react-toastify";
import UserWizard from "../components/user-wizard";

const Form = styled.div`
    display: flex;
    flex-direction: column;
    //justify-content: center;
    height: 100%;
    max-width: 600px;
    margin: 0 auto;
    gap: 1em;
    & > * {
        z-index: 2;
    }
`;

const Text = styled("span")(
    ({ theme, $primary, $grey }: any) => `
    font-weight: 500;
    font-size: 2.5rem;
    display: block;
    line-height: 1em;
    ${($primary && `color: ${theme.palette.primary.main};`) || ""}
    ${($grey && `color: ${theme.palette.grey.A700};`) || ""}
`
);

const mapDispatchToProps = { setUser };
type dispatchType = typeof mapDispatchToProps;

interface Props extends dispatchType {}

const Login = (props: Props) => {
    const { setUser } = props;
    const [screen, setScreen] = useState<string>("landing");
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [name, setName] = useState<string>("");
    const [userWizard, setUserWizard] = useState<any>({});
    const [emailAlreadyInUser, setEmailAlreadyInUse] = useState<boolean>(false);

    const handleSignIn = async () => {
        const authUser = await signInEmailAndPassword({ email, password });
        const user = await getCurrentUser(authUser.user.uid);
        setUser(user);
    };

    const handleSignUp = async () => {
        setEmailAlreadyInUse(false);
        let credentials;
        try {
            credentials = await signUpEmailAndPassword(email, password);
        } catch (err) {
            console.log(err);
            if (
                (err as any).message
                    .toString()
                    .includes("auth/email-already-in-use")
            ) {
                setEmailAlreadyInUse(true);
            }
            return;
        }
        const user = await createNewUser(email, credentials.user.uid, name);
        setUser({ ...user, _protectedRouteRedirect: "/user-wizard" });
    };

    return (
        <LoginLayout>
            <Container style={{ height: "100%" }} maxWidth="sm">
                <Form>
                    {screen === "landing" && (
                        <div style={{ textAlign: "center" }}>
                            <Text>Thoughtfully Grow</Text>
                            <Text $primary>Relationships</Text>
                            <Text
                                $grey
                                style={{ fontSize: "1.2em", marginTop: "1em" }}
                            >
                                Remember what matters about people that matter
                            </Text>
                        </div>
                    )}
                    {screen === "user-wizard" && (
                        <UserWizard
                            userObject={userWizard}
                            setUserObject={setUserWizard}
                        />
                    )}
                    {screen === "login-email" && (
                        <>
                            <TextField
                                label="Email"
                                value={email}
                                onChange={(
                                    evt: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    setEmail(evt.target.value);
                                }}
                            />
                            <TextField
                                label="Password"
                                type="password"
                                value={password}
                                onChange={(
                                    evt: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    setPassword(evt.target.value);
                                }}
                            />
                            <Text
                                style={{
                                    fontSize: "1em",
                                    width: "100%",
                                    textAlign: "center",
                                }}
                            >
                                {" "}
                                Don't have an account?{" "}
                                <Text
                                    $primary
                                    style={{
                                        fontSize: "1em",
                                        display: "inline",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        setEmail("");
                                        setPassword("");
                                        setName("");
                                        setScreen("register-email");
                                    }}
                                >
                                    Sign Up Here
                                </Text>{" "}
                            </Text>
                            <Button onClick={handleSignIn}>Sign In</Button>
                            <Button
                                onClick={() => setScreen("landing")}
                                color="black"
                            >
                                Go Back
                            </Button>
                        </>
                    )}
                    {screen === "register-email" && (
                        <>
                            <TextField
                                label="Email"
                                value={email}
                                onChange={(
                                    evt: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    setEmail(evt.target.value);
                                }}
                            />
                            <TextField
                                label="Full Name"
                                value={name}
                                onChange={(
                                    evt: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    setName(evt.target.value);
                                }}
                            />
                            <TextField
                                label="Password"
                                type="password"
                                value={password}
                                onChange={(
                                    evt: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                    setPassword(evt.target.value);
                                }}
                            />
                            {emailAlreadyInUser && (
                                <Text
                                    style={{
                                        fontSize: "1em",
                                        width: "100%",
                                        textAlign: "center",
                                    }}
                                >
                                    A user with this email address already
                                    exists. Please try again or contact{" "}
                                    <Text
                                        style={{
                                            fontSize: "1em",
                                            width: "100%",
                                            textAlign: "center",
                                            display: "inline",
                                        }}
                                        $primary
                                        as="a"
                                        href="mailto:support@networknerd.app"
                                    >
                                        support@networknerd.app
                                    </Text>{" "}
                                    for assistance.
                                </Text>
                            )}
                            <Text
                                style={{
                                    fontSize: "1em",
                                    width: "100%",
                                    textAlign: "center",
                                }}
                            >
                                Already have an account?{" "}
                                <Text
                                    $primary
                                    style={{
                                        fontSize: "1em",
                                        display: "inline",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        setScreen("login-email");
                                        setEmail("");
                                        setPassword("");
                                        setName("");
                                    }}
                                >
                                    Sign In Here
                                </Text>{" "}
                            </Text>
                            <Button onClick={handleSignUp}>Sign Up</Button>
                            <Button
                                onClick={() => setScreen("landing")}
                                color="black"
                            >
                                Go Back
                            </Button>
                        </>
                    )}
                    {screen === "landing" && (
                        <>
                            <GoogleOAuthProvider
                                clientId={
                                    process.env
                                        .REACT_APP_GOOGLE_OAUTH_CLIENT_ID || ""
                                }
                            >
                                <GoogleButton setUser={setUser} />
                            </GoogleOAuthProvider>
                            <Button
                                style={{ margin: "0 auto" }}
                                onClick={() => {
                                    setEmail("");
                                    setPassword("");
                                    setName("");
                                    setScreen("login-email");
                                }}
                            >
                                Sign in With Email
                            </Button>
                        </>
                    )}
                </Form>
            </Container>
        </LoginLayout>
    );
};

export default connect(null, mapDispatchToProps)(Login);
